import { Turbo } from '@hotwired/turbo-rails'

// Disable Turbo Drive globally to avoid regressions
// Only Turbo Frames will be used where explicitly needed
Turbo.session.drive = false
